import { ToggleButton, ToggleButtonGroup, Tooltip, SvgIconProps } from "@mui/material";
import BarChartIcon from "@mui/icons-material/BarChart";
import ListIcon from "@mui/icons-material/List";
import { colors } from "../../../../ui/colors";
import { cloneElement, isValidElement, ReactNode, ReactElement } from "react";

interface ToggleModeSwitchProps {
  mode?: string;
  onViewModeChange?: (mode: string) => void;
  iconGraph?: ReactNode;
}

export const ToggleModeSwitch = ({ mode = "graph", onViewModeChange, iconGraph }: ToggleModeSwitchProps) => {
  const handleToggle = (_event: React.MouseEvent<HTMLElement>, newMode: string | null) => {
    if (newMode !== null && onViewModeChange) {
      onViewModeChange(newMode);
    }
  };

  const renderIcon = (icon: ReactNode, defaultIcon: ReactElement) => {
    const element = isValidElement(icon) ? icon : defaultIcon;

    return cloneElement(element as ReactElement<any>, {
      sx: {
        fontSize: "12px",
        width: "20px",
        height: "28px",
        ...(element.props as any)?.sx,
      },
    });
  };

  return (
    <ToggleButtonGroup
      value={mode}
      exclusive
      onChange={handleToggle}
      aria-label="view mode"
      size="small"
      sx={{
        bgcolor: "background.paper",
        "& .MuiToggleButton-root": {
          px: 1,
          py: 0.5,
          mr: 1,
          borderRadius: "8px",
          border: "1px solid var(--fx-surface-border, #E2E8F0)",
          "&.Mui-selected": {
            bgcolor: colors.orange[300],
            color: "#ffffffff",
            "&:hover": {
              bgcolor: colors.orange[400],
            },
          },
        },
      }}
    >
      <Tooltip title="Graph View" placement="top">
        <ToggleButton value="graph" aria-label="graph view">
          {renderIcon(iconGraph, <BarChartIcon />)}
        </ToggleButton>
      </Tooltip>

      <Tooltip title="List View" placement="top">
        <ToggleButton value="list" aria-label="list view">
          {renderIcon(null, <ListIcon />)}
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
};
